import React from 'react';

const HowToPlay = () => {
  // Data for the sections to avoid repetition
  const sections = [
    {
      title: "About the Game",
      content: (
        <>
          <p className="mb-4">
            Satta is a broad word to describe <i>"betting"</i> in India or Hindi. The Matka game is sometimes referred to as Indian Satta Matka because of its early popularity. If you are interested in betting games, you can check out the numbers game. The game of online satta matka is pretty simple to understand and play. With a very little study and effort you can become online matka play king and earn huge amount. The kalyan matka game which is the online matka play market was the first online matka market introduced by Kalyanji Bhagat in 1962 and the online matka Waroli market was introduced back in 70's by Ratan Khatri.
          </p>

          <p className="mb-4 font-semibold">
            This is how you play matka on Bazigar:
          </p>

          <ul className="list-disc pl-6 mb-6 space-y-2">
            <li>
              Step 1 is to pick (3) numbers from 0–9. For example 5,3,6 would be your first picked random numbers from given 0–9. To add more thrill and substance to the diversion, the numbers are then included/added (5 + 3 + 6) and a last number is given. In this example it is 14. Now, you only have have to keep one digit of this number, that is the last one. In this example, it will be the 4. So your first draw would be 5,3,6 *4.
            </li>
            <li>
              There are also a second set of numbers which is drawn. The process is similar just like step 1. The rules for picking 2nd number is exactly same as the first draw. As an random case, lets accept the numbers 8,2,8. This gives us a sum of 18, we again just only keep the last digit so our last pick for the second draw of numbers is 8,2,8 *8
            </li>
            <li>
              Our last card would resemble this: 5,3,6 *4 X 8,2,8 *8. Here is an example card.
            </li>
          </ul>
        </>
      )
    },
    {
      title: "How to add money in Bazigar?",
      content: (
        <>
          <ul className="list-[circle] pl-6 mb-6 space-y-2">
            <li>Minimum Deposit is 100 /- Rs</li>
            <li>Minimum Withdraw is 1000/- Rs</li>
            <li>Maximum Withdraw Is 25 Lakh Per Day.</li>
            <li>Withdrawal request can be placed between 11 am to 11 pm, all 7 days.</li>
            <li>Once withdraw request is placed, amount will be deducted from your wallet & amount will be credited to your bank account with in 60 mins.</li>
            <li>Withdraw Is Available On Saturday & Sunday Also.</li>
            <li>Withdraw Is Not Available On Festivals.</li>
            <li>The amount of money you deposit accordingly the points will be added to your corresponding ID</li>
            <li>1 point = Rs. 1/-</li>
          </ul>

          <p className="mb-6">
            The game you played and got lucky enough to win it then accordingly your points will be increased.
            If you wish to encash the points, just apply for withdrawal request on our Bazigar Mobile App. 
            <br /><b>**</b> In case of any inconvenience regarding the transaction of money OR further query then you can WhatsApp us on <a href="https://wa.me/+919167555333" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-bold">+91 9167 555333</a>
          </p>
        </>
      )
    },
    {
      title: "Satta Matka Guide – How To Play & Win Money?",
      content: "Satta is a broad word to describe 'betting' in India or Hindi. The Matka game is sometimes referred to as Indian Satta Matka because of its early popularity. If you are interested in betting games, you can check out the numbers game at KingMatka.com"
    },
    {
      title: "WHAT IS SATTA BAZAR?",
      content: "Satta bazar is a highly local Indian term that means betting market. Indians love to bet on a number of things. They enjoy taking part in this activity and are therefore always willing to spend a significant amount of money in the game of Satta. Famous Form Of Satta Matka is both a lottery and a number-based game, and you have to pick a number to actually play the game and check for the turn and see whether or not your number has reached the ensuing place. Satta Matka is a form of gambling or lottery that came into India before the country got independent."
    },
    {
      title: "WHAT IS MATKA SATTA?",
      content: "Matka satta is one of the well-liked forms of betting in India. In matka satta, slips are pulled from a large earthenware pot known as matka. Sometimes, the winner is declared after dealing with the playing card. The lead person who runs the syndicate of matka gambling is known as a 'Matka King'. Kalyan and Worli are two of the most popular Matka Games."
    },
    {
      title: "WHERE TO GO FOR SATTA MATKA ONLINE FOR REAL MONEY",
      content: (
        <>
          Satta is not currently legal in India, but it is still big business. Lotteries have become more attractive online because they combine all lotteries on an international level, so those from India can leverage their bets by only picking lottery cards where the jackpot is the biggest. India has a relatively small lottery jackpot while the US and EU countries have jackpots commonly in the 100's of millions of Euros/USD. For other betting games, a large majority of Indians are still betting with local bookies, but more are using the internet at online casinos and online bookies like Betway for cricket and other sports or casino games.
          <br /><br /><b>Pick Numbers</b>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>You pick (3) three numbers from 0 – 9.</li>
            <li>For example, 5,3,6 would be your first pick at random.</li>
            <li>To add more substance to the game, the numbers are then added up (5 + 3 + 6) and a final Satta Matka number is given.</li>
            <li>In this example, it is 14. You only use one digit of this number, the last one. In this example, it will be the 4.</li>
            <li>So your first draw would be 5,3,6 *4.</li>
            <li>The second set of numbers is also drawn. They are drawn in the exact same way as the first draw.</li>
            <li>As a random example, let's assume the numbers 8,2,8. This gives us a total of 18, we again only use the last digit so our final pick for the second set of numbers is 8,2,8 *8</li>
            <li>Our final card would look like this: 5,3,6 *4 X 8,2,8 *8. Here is an example card you would find in a matka game.</li>
          </ul>
        </>
      )
    },
    {
      title: "How Do You Win At Matka?",
      content: "To win at Matka Satta, you have various rate payouts, ranging from 9/1 to 999/1. You can bet on the chance of all numbers coming up to the first, last, or any other type of bet allowed by the Matka gambling bookie. For this reason, it can be an attractive game because of the payout multiples, but the game is merely a game of chance and therefore can not be beaten. It requires luck to win, but many are superstitious about their numbers and always play them, just like the lottery games."
    },
    {
      title: "SATTA MATKA FEES & ODDS",
      content: (
        <>
          The Satta betting agent should only take a maximum of 5% of your wager amount assuming you win. Because the game is all luck and neither the agent nor the bettor has an advantage, the bookie should take home 5% on every Rupee wagered. Heavy betting on a certain number or combination of numbers can be a dangerous scenario. If those numbers come up, it is very likely your bookie will vanish because he can't afford to cover the wagers. When the cards and numbers are picked, generally at 9 PM and 12 at night the winners are declared. This is how a payout would occur.
          <br /><br />Example Of A 10 Rupees Bet:
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>You choose the correct first number drawn: 9 X Your Wager of 10Rs = 90 Rs.</li>
            <li>Your second number is drawn: 9 X Your Wager of 10Rs = 90 Rs.</li>
            <li>You choose the middle number (the jodi) and the first number correct in combination: 90 X Your Wager = 900 Rs.</li>
          </ul>
          <button className="text-orange-500 underline font-medium">Play Live Lottery Games Today!</button>

        </>
      )
    },
    {
      title: "HISTORY OF SATTA MATKA",
      content: "The origins of Indian Matka gambling involve wagering on the daily price of cotton according to the Bombay and the New York Cotton Exchange. Nowadays, Matka betting, or Satta King, is a popular lottery-style game. It involves the selection of random numbers in the hopes of hitting the right number combination. The winner becomes the Satta King and they earn the bulk of the prize pool. The legendary Ratan Khatri is popularly known as the Matka King. After his arrest in 1995, he had to discontinue his games and now crooks are running the game he loved so much by fixing the numbers. A big fall from grace, but his name remains legendary among Satta Matka games in Mumbai."
    },
    {
      title: "CONCLUSION ON SATTA MATKA",
      content: "Big-time enthusiasts still play this game and they remember the days of Ratan having celebrities pull draws for him. The game has since lost most of its following. Indians have chosen the faster-paced action of online cricket betting or live dealer casinos on their mobile devices. IPL betting draws people like nothing else in India and fans wait eagerly to place bets on the event."
    }
  ];

  return (
    <div className="flex flex-col items-center min-h-screen mt-[2.5cm] ">
      <div className="w-full max-w-6xl px-4">
        {sections.map((section, index) => (
          <section key={index} className={`mb-8 ${index === 0 ? 'text-center' : ''}`}>
            {index === 0 ? (
              <>
                <h1 className="text-3xl font-bold text-gray-800">{section.title}</h1>
                <div className="h-1 w-20 bg-orange-500 mx-auto mt-4 mb-8"></div>
              </>
            ) : (
              <h2 className="text-2xl font-bold mb-4 text-gray-800">{section.title}</h2>
            )}
            <div className="text-gray-700">
              {section.content}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default HowToPlay;